import { NodeSelection, Selection } from 'prosemirror-state'
import { Node, ResolvedPos } from 'prosemirror-model'
import { findParentNode, findParentNodeOfTypeClosestToPos } from 'prosemirror-utils'
import { Maybe } from 'types'
import { schema, tableNodesSpec, Attributes } from 'prose-core'

import { CellSelection } from './CellSelection'

export enum LineMode {
  Row,
  Column,
}

export const findTableFromPos = (posInTable: number, doc: Node) =>
  findParentNodeOfTypeClosestToPos(doc.resolve(posInTable), schema.nodes.table)

export const findTableFromSel = (selection: Selection): { node: Node; pos: number } | undefined =>
  isTableSelection(selection)
    ? {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        node: selection.$from.nodeAfter!,
        pos: selection.from,
      }
    : findParentNode((node) => node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection)

export const isTable = (node: Maybe<Node | undefined>) => {
  if (!node) return false

  return [schema.nodes.table].includes(node.type)
}

export const isTableCell = (node: Maybe<Node | undefined>) => {
  if (!node) return false

  return ['table_header', 'table_cell'].includes(node.type.name)
}

export const inTableCell = ($from: ResolvedPos) => {
  const thisNode = $from.node()
  const parentNode = $from.node($from.depth - 1)

  if (!thisNode || !parentNode) return false

  return isTableCell(thisNode) || isTableCell(parentNode)
}

export const isTableSelection = (selection: Selection): selection is NodeSelection =>
  selection instanceof NodeSelection && selection.node.type === schema.nodes.table

export const isCellSelectionIncluding = ($pos: ResolvedPos, selection: Selection): Boolean =>
  selection instanceof CellSelection && selection.$includedCells.map(($c) => $c.pos).includes($pos.pos)

export const isTableSelectionIncluding = ($pos: ResolvedPos, selection: Selection) =>
  selection instanceof NodeSelection &&
  selection.node.type === schema.nodes.table &&
  $pos.pos > selection.from &&
  $pos.pos < selection.to

export const cellAttrs: Attributes = {
  ...tableNodesSpec.cellAttributes,
  borderLeft: {
    setDOMAttr: (attrValue, attrs) => {
      if (!attrs.style) attrs.style = ''
      attrs.style += `border-left:${attrValue};`
    },
  },
  borderRight: {
    setDOMAttr: (attrValue, attrs) => {
      if (!attrs.style) attrs.style = ''
      attrs.style += `border-right:${attrValue};`
    },
  },
  borderTop: {
    setDOMAttr: (attrValue, attrs) => {
      if (!attrs.style) attrs.style = ''
      attrs.style += `border-top:${attrValue};`
    },
  },
  borderBottom: {
    setDOMAttr: (attrValue, attrs) => {
      if (!attrs.style) attrs.style = ''
      attrs.style += `border-bottom:${attrValue};`
    },
  },
}
